import classNames from 'classnames';
import styles from './FJGradientHoverBox.module.less';
import PropTypes from 'prop-types';

const FJGradientHoverBox = props => {
    const { className, children, selected = false, onClick, data, onMouseEnter, onMouseLeave } = props;
    return (
        <div
            className={classNames(styles.box, className, selected && styles.selected)}
            onClick={onClick}
            data={data}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
        >
            <div className={styles.inner}>{children}</div>
            <div className={styles.inner_border} />
        </div>
    );
};

FJGradientHoverBox.propTypes = {
    className: PropTypes.string,
    children: PropTypes.node,
    selected: PropTypes.bool,
    onClick: PropTypes.func,
    data: PropTypes.object,
    onMouseEnter: PropTypes.func,
    onMouseLeave: PropTypes.func,
};
export default FJGradientHoverBox;
